/**
 * The step before / after a Client, Property or Scheduling page, for the mockup's "Back to …" and
 * "Continue to …" buttons. Their order is Settings > Inspection Tab Order, which the workflow tab
 * bar stores in localStorage 'tab_orders' (key order = tab order) - the same list the pages'
 * save handlers navigate by.
 */
export interface IntakeStep {
    key: string;
    label: string;
    link: string;
}

const LABELS = { client: 'Client', property: 'Property', scheduling: 'Scheduling' };

export function intakeStep(current: string, offset: number): IntakeStep {
    let order = null;
    try {
        order = JSON.parse(localStorage.getItem('tab_orders') || 'null');
    } catch (e) { }
    if (!order) {
        return null;
    }
    const keys = Object.keys(order);
    const index = keys.indexOf(current);
    const key = index < 0 ? null : keys[index + offset];
    return key && order[key] ? { key, label: LABELS[key] || key, link: order[key] } : null;
}
